// extracted by mini-css-extract-plugin
export default {"root":"UnderwritingQuestionCard_root__SxAUu"};